import { c as _c } from "react/compiler-runtime";
import type { GiftProductApiDto } from '__generated__/api/unauth/types.gen';
import { GiftCard } from '@/app/_components/GiftCard/GiftCard';
import { ROUTES } from '@/constants';
import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';
const PREVIEW_SLIDER_COUNT = 5;
export function GiftPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  const t1 = isLoading ? undefined : totalCount;
  let t2;
  if ($[0] !== keyword) {
    t2 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "gifts"
      }
    });
    $[0] = keyword;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SectionHeader title={"\uB2F5\uB840\uD488"} totalCount={t1} moreHref={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoading || $[6] !== items) {
    t4 = isLoading ? <HorizontalSlider className="mobile-tablet:pl-20">{Array.from({
        length: PREVIEW_SLIDER_COUNT
      }, _temp)}</HorizontalSlider> : <HorizontalSlider className="mobile-tablet:pl-20">{items.map(_temp2)}</HorizontalSlider>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <section className="flex w-full flex-col">{t3}{t4}</section>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(item) {
  return <div key={item.productNumber ?? item.productId} className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"><GiftCard mainImageUrl={item.mainImageUrl} productName={item.productName} donationAmount={item.requiredDonationAmount} reviewRating={item.reviewRating} reviewCount={item.reviewCount} productNumber={item.slugId ?? item.productNumber} /></div>;
}
function _temp(_, index) {
  return <div key={index} className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"><GiftCard isLoading={true} /></div>;
}